import React from 'react'

import { Formik, Field } from 'formik'

import { ZariContext } from '_zari/context'

import { Modal, Form, Col, Button } from '_zari/core'

import * as FamiliasService from 'services/familia.service'

import CategoriaFormGroup from '../formGroups/categoria'

import { Row } from 'react-bootstrap'

const NuevaFamiliaModal = ({ show, handleClose, editData, tablaRef }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    
    return {
      nombre: editData.nombre,
      _idCategoria: editData._idCategoria
    }
  }, [editData])

  const onSubmit = React.useCallback(
    async data => {
      if (editData.nombre !== '') {
        FamiliasService.actualizarFamilia(editData.id, data).then(() => {
          __zariContext.snack('success', 'Familia actualizada')
          handleClose()
        })
        tablaRef.current.reload()
      } else {
        FamiliasService.insertarFamilia(data).then(() => {
          __zariContext.snack('success', 'Familia creada.')
          handleClose()
        })
        tablaRef.current.reload()
      }
    },
    [__zariContext, editData, handleClose, tablaRef]
  )

  return (
    <Modal show={show} size='sm'>
      <Modal.Header>
        <Modal.Title>{editData.title}</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={onSubmit}>
        {({ errors, touched, isSubmitting, values, setValues, handleSubmit, handleChange }) => (
          <Form>
            <Modal.Body>
              <Form.Group>
                <Row>
                  <Col sm={6} md={12}>
                    <CategoriaFormGroup
                      iError={errors.categoria}
                      iTouched={touched.categoria}
                      fIsSubmitting={isSubmitting}
                      values={values}
                      setValues={setValues}
                      handleChange={handleChange}
                    />
                  </Col>
                </Row>
                <Row>
                  <Form.Label text='NOMBRE' md={4} alignRightAt='md' />
                  <Col md={8}>
                    <Field name='nombre'>
                      {({ field }) => (
                        <Form.InputText {...field} isInvalid={touched.nombre && errors.nombre} disabled={isSubmitting} id='input-nombre' />
                      )}
                    </Field>
                  </Col>
                </Row>
                {touched.nombre && errors.nombre ? <Form.Feedback type='invalid'>{errors.nombre}</Form.Feedback> : null}
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={handleClose}>Cancelar</Button>
              <Button onClick={handleSubmit}>Guardar</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(NuevaFamiliaModal)
